import { FlashMessages } from '../components/Flash/redux/flash-messages';

const reallyWeirdErrorMessage = {
  type: 'danger',
  message: FlashMessages.ReallyWeird
};

export default reallyWeirdErrorMessage;
